@import '../../../theme/colors';

.segmentResultsRoot {
  box-sizing: border-box;
  width: 100%;
  margin-top: 18px;
  padding: 16px;
  padding-left: 32px;
  background-color: $iceBlue;
  overflow-x: auto;
}

// Indicate stale data while new data is being fetched
.previousData {
  opacity: 0.7;
}

.results {
  color: #020202;
  font-family: var(--font-family__body);
  letter-spacing: 0;
  border-collapse: collapse;

  tr {
    td {
      padding-bottom: 6px;
    }

    td:first-child {
      text-align: right;
      font-size: 18px;
      line-height: 23px;
      padding-right: 26px;
    }
    
    td:nth-child(2) {
      text-align: left;
      font-size: 12px;
      line-height: 15px;
      text-transform: uppercase;
    }
  }

  tr:nth-child(2) {
    td {
      padding-bottom: 12px;
    }
  }
  
  tr:nth-child(3) {
    td {
      padding-top: 10px;
      border-top: 1px solid $neutral-500;
    }

    td:first-child {
      font-size: 24px;
      line-height: 31px;
    }
    
    td:nth-child(2) {
      font-weight: 600;
    }
  }
}

.loading {
  position: absolute;
  margin-left: -26px;
  margin-top: -10px;
}